export const handleBackdropClick = ({ event, onClose, ref }) => {
    if (!onClose)
        return;
    /* This logic only works because the direct child <div> of <dialog>
     ** takes all the space within the <dialog> container. When <dialog> has a padding,
     ** the click detection also fires on that padding area.
     */
    if (ref.current && event.target === ref.current) {
        onClose();
    }
};
//# sourceMappingURL=handle-backdrop-click.js.map